var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenOperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 15.2717H16.0417M3.315 0.625H9.09667C9.70998 0.625 10.2982 0.868638 10.7319 1.30232C11.1655 1.73599 11.4092 2.32419 11.4092 2.9375V15.2708H1.0025V2.9375C1.0025 2.32419 1.24614 1.73599 1.67982 1.30232C2.11349 0.868638 2.70169 0.625 3.315 0.625Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89331 3.70917H8.51831M3.89331 6.7925H8.51831M11.4083 5.63583H12.95C13.2538 5.63562 13.5547 5.69527 13.8354 5.81138C14.1162 5.9275 14.3713 6.0978 14.5862 6.31256C14.8012 6.52732 14.9716 6.78232 15.088 7.06299C15.2043 7.34367 15.2641 7.64451 15.2641 7.94833V15.2717M5.44248 9.87583H6.98414C7.29078 9.87605 7.58481 9.99785 7.80179 10.2145C8.01877 10.4312 8.14098 10.725 8.14164 11.0317V15.2717H4.28664V11.0317C4.28664 10.7251 4.40842 10.4311 4.62518 10.2144C4.84194 9.99761 5.13593 9.87583 5.44248 9.87583Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenOperator);
export default __webpack_public_path__ + "static/media/KitchenOperator.01d1f2b62eeb701eff409354f5773fb2.svg";
export { ForwardRef as ReactComponent };